import { createFileRoute } from "@tanstack/react-router";
import AdminSmsPage from "@/admin/pages/sms";

export const Route = createFileRoute("/admin/sms/")({
  component: AdminSmsPage,
});
